
import {config} from './config.mjs';
import App from '@mecatran-projects/widget-alerts';
import "./style.css";

var app = new App(config);
app.run();